<template>
  <div class="about">
    <h1 class="title">Welcome to {{  system_title }}</h1>

    <p>To submit your application, you will need to fill in a few intial sections of the application form. </p>
    <p>We will then contact you to advise if the process can continue and you will be asked for more information at that stage.</p>
<br />
<div class="notification is-warning">
                <p>To apply you must have a valid right to work within the UK, 3-6 months UK experience.</p>

                </div>

    <p><router-link to="/new"><button class="button is-success">Start a New Application</button></router-link></p>
  </div>
</template>

<script>
    
    export default {
      name: 'Home',
        mixins: [],
        props: [],
        data: function () {
            return {
              system_title : process.env.VUE_APP_SYSTEM_TITLE,
            }
        },
    }
  </script>
